import useRootStore from './useRootStore';

export default function useSearchProducers() {
  const { searchProducersStore } = useRootStore();
  return searchProducersStore;
}
